module.exports = __webpack_public_path__ + "img/compare.e33a2fa8.svg";